import 'slick-carousel';
import * as SmoothScroll from 'smooth-scroll';
import { HeaderController } from './controllers/header.controller';
import { NavController } from './controllers/nav.controller';

// ----------------------------------------------------------------
// globals

let scroll: SmoothScroll;
const app: { [ key: string ]: any; } = {
  header: new HeaderController(),
  nav: new NavController()
};
( window as any ).app = app;

// ----------------------------------------------------------------
// event handlers

function onDocumentReady() {
  // IE11 min-height fix on .grid-css
  const homeIntroBox = $( '#page-home > main > .home-intro.grid-css' );
  if ( homeIntroBox ) {
    const boxHeight = homeIntroBox.height() as number;
    const wh = window.innerHeight;
    if ( boxHeight < wh ) {
      homeIntroBox.height( wh );
    }
  }

  // initialize slick slider
  $( '.slider' ).slick(
    {
      slidesToShow: 6,
      autoplay: false,
      infinite: true,
      arrows: true,
      dots: false,
      nextArrow: '<span class="button-icon__right button-icon-blue-white button-icon-hover-to-blue slick-next"></span>',
      prevArrow: '<span class="button-icon__left button-icon-blue-white button-icon-hover-to-blue slick-prev"></span>',
      respondTo: 'window',
      responsive: [
        {
          breakpoint: 1201, // active at <= 1200px
          settings: {
            slidesToShow: 5
          }
        },
        {
          breakpoint: 994, // active at <= 993px
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 768, // active at <= 767px
          settings: {
            slidesToShow: 2,
            arrows: true
          }
        },
        {
          breakpoint: 481, // active at <= 480px
          settings: {
            slidesToShow: 1,
            arrows: true
          }
        }
      ]
    }
  );
}

function onWindowLoaded() {
  // initialize smooth scroll
  // https://www.npmjs.com/package/smooth-scroll
  scroll = new SmoothScroll( 'a[href*="#"]' );

  // check for URL hash and animate scroll, if set
  setTimeout(
    () => {
      scrollToHashIfSet();
    },
    300
  );
}

// ----------------------------------------------------------------
// register event handlers

$( onDocumentReady );
$( window ).on( 'load', onWindowLoaded );

// ----------------------------------------------------------------
// other crazy stuff

function scrollToHashIfSet(): void {
  let hash = window.location.hash;
  if ( typeof hash === 'string' && hash.length > 1 ) {
    hash = hash.substr( 1 );
    const targetEl = document.getElementById( hash );
    if ( targetEl && 'offsetTop' in targetEl ) {
      // https://www.npmjs.com/package/smooth-scroll#animatescroll
      scroll.cancelScroll(); // fix for offset bug on click after scroll
      scroll.animateScroll(
        targetEl,
        undefined,
        {
          header: 'header'
        }
      );
    }
  }
}
